export default __webpack_public_path__ + "static/media/pms-startegy-banner.4caac4a7.png";